import Dialog, { DialogProps } from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

import { useDispatchSetSelectedModal, useModalState } from '../../contexts/modal-context/modal-context'

export type ActionModalType = {
  component: React.FC<any> | React.VFC<any>,
  componentProps?: any,
  formData?: any,
  label: string,
  onSuccess?: () => void,
	width?: number,
	onXClick?: () => void,
};

export default function ActionModal(): JSX.Element | null {
	const selectedModal: ActionModalType | undefined = useModalState()
	const setSelectedModal = useDispatchSetSelectedModal()

	const closeModal = () => setSelectedModal( undefined )

	if ( !selectedModal ) {
		return null
	}

	const Component = selectedModal.component
	const { formData, componentProps, width } = selectedModal

	const onSuccess = () => {
		if ( selectedModal.onSuccess ) {
			selectedModal.onSuccess()
		}
		closeModal()
	}

	const onCloseClick = () => {
		selectedModal.onXClick?.()
		closeModal()
	}

	// EuiModal parity: ESC dismisses, backdrop clicks don't (bodies are mostly forms)
	const onClose: DialogProps['onClose'] = ( _event, reason ) => {
		if ( reason !== 'backdropClick' ) {
			onCloseClick()
		}
	}

	return (
		<Dialog
			open
			onClose={onClose}
			maxWidth={width ? false : 'md'}
			slotProps={{ paper: { sx: { width } } }}
		>
			<DialogTitle sx={{ pr: 7 }}>
				{selectedModal.label}
			</DialogTitle>
			<IconButton
				aria-label="Close"
				onClick={onCloseClick}
				sx={{ position: 'absolute', top: 8, right: 8 }}
			>
				<CloseIcon />
			</IconButton>

			<Component
				onCancel={closeModal}
				onSuccess={onSuccess}
				formData={formData}
				{...componentProps}
			/>
		</Dialog>
	)
}
